import { config } from "../../config/config";

export const getHostUrl = (): string => {
  type EnvKey = keyof typeof config;
  const env: EnvKey = (
    process.env.REACT_APP_NODE_ENV === "prod"
      ? "prod"
      : process.env.REACT_APP_NODE_ENV === "dev"
        ? "dev"
        : "local"
  ) as EnvKey;
  return config[env].BACKEND_URL;
  // return 'https://api.kwikmedia.in'
  // return 'http://kwikmedia-LB-1876535244.ap-south-1.elb.amazonaws.com'
};

// http://159.89.162.41:8000
// https://photo-app-be-python.onrender.com
// paste here ==> https://0698-106-202-194-50.ngrok-free.app
